class SubscriptionModal extends HTMLElement {
  optionIsAmount = (option) => {
    if (option.name.toLowerCase() === "amount")
      return true;
    return option.values.find((v) => {
      const valueWord1 = v.label.split(" ")[0];
      return /^\d*$/.test(valueWord1);
    })
  }

  constructor() {
    super();
    this.waitForRcProduct().then(() => {
      this.init();
      this.form = this.querySelector('form');
      this.defaultAmount = this.dataset.amount;
      this.orderIntervalUnitTypeTranslations = JSON.parse(this.dataset.orderIntervalUnitTypeTranslations.replaceAll('=>', ':'));
      this.currency_symbol_position = this.dataset.currencySymbolPosition;
      this.cartNotification = document.querySelector('cart-notification');
      this.amountLabel = document.querySelector('#subscription-modal_amount-label');
      this.deliverEveryLabel = document.querySelector('#subscription-modal_deliver-every-label');
      this.amountPrices = document.querySelectorAll('.subscription-modal_amount-price');
      this.totalPrices = document.querySelectorAll('.subscription-modal_total_price');
      this.perOneLabels = document.querySelectorAll('.subscription-modal_per_one');
      this.savingLabels = document.querySelectorAll('.subscription-modal_saving');
      this.amountCustom = document.querySelector('#amount_custom');
      this.deliverEveryCustom = document.querySelector('#deliver-every_custom');
      this.deliverFreeShipping = document.querySelectorAll('[data-deliver-free_shipping]');
      this.deliverFreeShippingThreshold = Number(this.deliverFreeShipping[0].dataset.threshold) * 100;
      this.submitBtnSpinners = document.querySelectorAll('.subscription-modal_buttons button[type="submit"] .loading-overlay__spinner');
      this.form.addEventListener('submit', this.formSubmit.bind(this));
      this.form.addEventListener('change', this.formChange.bind(this));
      this.currencySymbol = "$";
      this.amounts = [];

      // We set it up in rc-subscription-product-vetz.liquid
      this.currencySymbol = Shopify.activeCurrencySymbol;

      if (this.rechargeVersion !== "1")
        this.setWidgetText(window.rcProduct.firstVariantId);

      if (window.location.href.includes("subscription-modal_form_step")) {
        this.open();
      }
    });
  }

  waitForRcProduct(retries) {
    return new Promise((resolve, reject) => {
      if (!retries && retries !== 0)
        retries = 200;
      if (retries < 0) {
        return reject("Timeouted");
      }
      if (!window.rcProduct) {
        retries--;
        setTimeout(_ => {
          resolve(this.waitForRcProduct(retries));
        }, 300)
      } else {
        this.rechargeVersion = window.rcProduct.rechargeVersion;
        return resolve();
      }
    });
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  formChange(evt) {
    if (evt.target.name === "weight") {
      let amount = "90";

      let recommendedAmount = this.getAmountByVariant(window.rcProduct.small_recommended_variant);
      if (recommendedAmount)
        amount = recommendedAmount;

      if (window.rcProduct.small_recommended_frequency) {
        this.deliverEveryCustom.value = window.rcProduct.small_recommended_frequency;
        this.deliverEveryLabel.innerHTML = window.rcProduct.small_recommended_frequency;
      }
      if (evt.target.value === "large") {
        const recommendedAmount = this.getAmountByVariant(window.rcProduct.large_recommended_variant);
        if (recommendedAmount)
          amount = recommendedAmount;
        else
          amount = this.getBiggestAmount();
        if (window.rcProduct.large_recommended_frequency) {
          this.deliverEveryCustom.value = window.rcProduct.large_recommended_frequency;
          this.deliverEveryLabel.innerHTML = window.rcProduct.large_recommended_frequency;
        }
      }
      this.updateValues(amount);
    } else if (evt.target.name === "amount_custom")
      this.updateValues(evt.target.value);
    else if (evt.target.name === "deliver-every_custom")
      this.deliverEveryLabel.innerHTML = evt.target.value;

    if (this.rechargeVersion !== "1") {
      this.setSellingPlan();
    }
  }

  setSellingPlan() {
    for (const sellingPlan of window.rcProduct.product.selling_plan_groups[0].selling_plans) {
      if (sellingPlan.order_interval_frequency === parseInt(this.deliverEveryLabel.innerHTML))
        this.selectedVariant.selectedSellingPlan = sellingPlan.selling_plan_id;
    }
  }

  updateValues(amount) {
    this.selectedVariant = this.getVariantByAmount(amount);

    this.amountLabel.innerHTML = amount;

    this.amountPrices.forEach(amountPrice => {
      amountPrice.innerHTML = this.currency_symbol_position == 'true' ? this.currencySymbol + (this.selectedVariant.price / 100).toFixed(2) : (this.selectedVariant.price / 100).toFixed(2) + ' ' + this.currencySymbol;
    });

    this.totalPrices.forEach(totalPrice => {
      totalPrice.innerHTML = this.currency_symbol_position == 'true' ? this.currencySymbol + (this.selectedVariant.duplicatePrice / 100).toFixed(2) : (this.selectedVariant.duplicatePrice / 100).toFixed(2) + ' ' + this.currencySymbol;
    });

    this.deliverFreeShipping.forEach(deliverFreeShipping => {
      deliverFreeShipping.innerHTML = this.deliverFreeShippingThreshold < this.selectedVariant.duplicatePrice ? deliverFreeShipping.dataset.free : deliverFreeShipping.dataset.paid;
    });

    this.perOneLabels.forEach(perOneLabel => {
      perOneLabel.innerHTML = this.currency_symbol_position == 'true' ? this.currencySymbol + (this.selectedVariant.duplicatePrice / 100 / parseInt(amount)).toFixed(2) : (this.selectedVariant.duplicatePrice / 100 / parseInt(amount)).toFixed(2) + ' ' + this.currencySymbol;
    });

    this.savingLabels.forEach(savingLabel => {
      savingLabel.innerHTML = this.currency_symbol_position == 'true' ? this.currencySymbol + (this.selectedVariant.price / 100 - this.selectedVariant.duplicatePrice / 100).toFixed(2) : (this.selectedVariant.price / 100 - this.selectedVariant.duplicatePrice / 100).toFixed(2) + ' ' + this.currencySymbol;
    });


    this.amountCustom.value = amount;
  }

  getAmountByVariant(variant) {
    let amount = null;
    if (variant) {
      for (const option of variant.options) {
        const a = option.split(" ")[0];
        if (/^\d*$/.test(a)) {
          amount = a;
          break;
        }
      }
    }
    return amount;
  }

  getVariantByAmount(amount) {
    let variant = null;
    if (this.rechargeVersion === "1") {
      variant = window.rcProduct.variant_options.find(v => v.options.includes(amount));
      if (variant) {
        variant.price = window.rcProduct.variant_to_price[variant.id];
        variant.duplicate = window.rcProduct.variant_to_duplicate[variant.id];
        variant.duplicatePrice = window.rcProduct.duplicate_to_price[variant.duplicate];
      }
    } else {
      variant = window.rcProduct.product.variants.find(v => {
        for (const optionValue of v.option_values) {
          if (optionValue.label.includes(amount))
            return true;
        }
        return false;
      });
      if (variant) {
        variant.price = parseFloat(variant.prices.unit_price) * 100;
        variant.duplicate = variant.id;
        variant.duplicatePrice = parseFloat(variant.prices.discounted_price) * 100;
      }
    }
    return variant;
  }

  toggleSubmitSpinners(state) {
    this.submitBtnSpinners.forEach(spinner => {
      if (state === "hide") {
        spinner.classList.add("hidden");
      } else {
        spinner.classList.remove("hidden");
      }
    })
  }

  formSubmit(evt) {
    evt.preventDefault();
    let productToAdd = null;

    const properties = {
      "_pet_breed": this.form.elements["pet_breed"].value,
      "_pet_name": this.form.elements["pet-name"].value,
      "_pet_first_time": this.form.elements["first-time"].value
    };

    if (this.rechargeVersion === "1") {
      properties.subscription_id = window.rcProduct.subscription_id;
      properties.shipping_interval_unit_type = window.rcProduct.shipping_interval_unit_type;
      properties.shipping_interval_frequency = this.deliverEveryCustom.value;
    }

    if (this.dataset.petType === "Dog")
      properties["_dog_size"] = this.form.elements["weight"].value;

    if (this.rechargeVersion === "1") {
      productToAdd = {
        id: this.selectedVariant.duplicate,
        quantity: 1,
        properties: properties,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
    } else {
      productToAdd = {
        id: this.selectedVariant.duplicate,
        quantity: 1,
        properties: properties,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
        selling_plan: this.selectedVariant.selectedSellingPlan
      }
    }

    this.cartNotification.setActiveElement(document.activeElement);
    this.toggleSubmitSpinners("show");
    fetch("/cart/add.js", {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(productToAdd)
    }).then((response) => response.json())
      .then((response) => {
        if (response.status) {
          return;
        }
        this.toggleSubmitSpinners("hide");
        this.close();
        this.cartNotification.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
      });;
  }

  setOption(optionAmount, amount, label) {
    this.amounts.push(parseInt(optionAmount));
    this.amountCustom.innerHTML += `<option value="${optionAmount}" ${optionAmount == amount ? "selected" : ""}>${label}</option>`;
  }

  setEditScreen(amount) {
    this.amountCustom.innerHTML = "";
    this.deliverEveryCustom.innerHTML = "";
    this.amounts = [];
    if (this.rechargeVersion === "1") {
      for (const option of window.rcProduct.variant_options) {
        const optionAmount = option.options.split(" ")[0];
        this.setOption(optionAmount, amount, option.options);
      }
    } else {
      let option = null;
      for (const o of window.rcProduct.product.options) {
        if (this.optionIsAmount(o))
          option = o;
      }

      if (!option)
        option = window.rcProduct.product.options[0];

      for (const optionVal of option.values) {
        const optionAmount = optionVal.label.split(" ")[0];
        this.setOption(optionAmount, amount, optionVal.label);
      }
    }

    let defaultShippingFrequency = "12";
    if (window.rcProduct.small_recommended_frequency)
      defaultShippingFrequency = window.rcProduct.small_recommended_frequency;

    if (this.rechargeVersion === "1") {
      for (const weeks of window.rcProduct.shipping_interval_frequency) {
        this.deliverEveryCustom.innerHTML += `<option value="${weeks}" ${weeks == defaultShippingFrequency ? "selected" : ""}>${weeks} weeks</option>`;
      }
    } else {
      for (const sellingPlan of window.rcProduct.product.selling_plan_groups[0].selling_plans) {
        this.deliverEveryCustom.innerHTML += `<option value="${sellingPlan.order_interval_frequency}" ${sellingPlan.order_interval_frequency.toString() == defaultShippingFrequency ? "selected" : ""}>${sellingPlan.order_interval_frequency} ${this.orderIntervalUnitTypeTranslations[sellingPlan.order_interval_unit_type]}s</option>`;
      }
    }
  }

  setWidgetText(variantId) {
    const oneTimeLabel = document.querySelector("label[for=rc_purchase_onetime]");
    const autodeliverLabel = document.querySelector("label[for=rc_purchase_type_autodeliver]");
    const discountPercentageLabel = document.querySelectorAll(".subscription-modal_recommended-option_discount");
    const showOneTimeLabelPrice = oneTimeLabel.dataset.showPrice;

    window.ReChargeWidget.api.fetchWidgetData().then((data) => {
      const variant = window.rcProduct.product.variants.find(v => v.id === variantId);
      const sellingPlan = window.rcProduct.product.selling_plan_groups[0].selling_plans[0];
      let savingsString = "";
      if (sellingPlan.price_adjustments_value_type === "percentage") {
        savingsString += ` (${sellingPlan.price_adjustments_value}%)`;
      }
      if (showOneTimeLabelPrice == "true") {
        oneTimeLabel.innerHTML = data.widgetSettings.onetime_message + `:&nbsp;<span id="rc_price_onetime" class="rc_price rc_price__onetime">${data.storeSettings.store_currency.currency_symbol}${variant.prices.unit_price}</span>`;
        autodeliverLabel.innerHTML = data.widgetSettings.subscribe_message + `${savingsString}:&nbsp;<span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver">${data.storeSettings.store_currency.currency_symbol}${variant.prices.discounted_price}</span>`;
      } else {
        oneTimeLabel.innerHTML = data.widgetSettings.onetime_message;
        autodeliverLabel.innerHTML = data.widgetSettings.subscribe_message;
      }
      discountPercentageLabel.forEach((el) => {
        el.innerHTML = sellingPlan.price_adjustments_value;
      });
    });
  }

  init() {
    const activationButtons = document.getElementsByName(`${this.dataset.id}-btn`);
    const closeButton = this.querySelector('.close');
    this.onBodyClick = this.handleBodyClick.bind(this);
    closeButton.addEventListener("click", this.onBodyClick);
    activationButtons.forEach((activationButton) => {
      activationButton.addEventListener("click", () => this.open());
    });
  }

  open() {
    this.updateValues(this.defaultAmount);
    this.setEditScreen(this.defaultAmount);
    window.location = '#subscription-modal_form_step1';
    this.classList.add("opened");
    if (this.rechargeVersion !== "1")
      this.setSellingPlan();

    // Disabled due to the incompatability with the cart popup
    // (this popup doesn't get opened if the cart popup is opened at the same time)
    // setTimeout(() => {
    //   document.body.addEventListener('click', this.onBodyClick);
    // }, 500);
  }

  close() {
    this.classList.remove("opened");
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (!target.closest('.popup-modal__content') || target.classList.contains("close")) {
      this.close();
      document.body.removeEventListener('click', this.onBodyClick);
    }
  }

  getBiggestAmount() {
    let amount = 0;
    for (const a of this.amounts) {
      if (a > amount) {
        amount = a;
      }
    }

    return amount.toString();
  }
}

customElements.define('subscription-modal', SubscriptionModal);

window.addEventListener('load', () => {
  const rcSubscriptionInputs = document.getElementsByName("purchase_type");
  const autoDeliverInput = document.getElementById("rc_purchase_type_autodeliver");
  const firstTimeInput = document.getElementById("rc_purchase_firsttime");
  const hiddenBlocks = document.querySelectorAll(".rc_autodeliver--hidden");
  const shownBlocks = document.querySelectorAll(".rc_autodeliver--shown");
  const firstTimeBlocks = document.querySelectorAll(".rc_firsttime--shown");

  rcSubscriptionInputs.forEach((inp) => {
    inp.addEventListener("change", () => {
      triggerSubscriptionType(autoDeliverInput, firstTimeInput, hiddenBlocks, shownBlocks, firstTimeBlocks);
    })
  });
  triggerSubscriptionType(autoDeliverInput, firstTimeInput, hiddenBlocks, shownBlocks, firstTimeBlocks);
});

function triggerSubscriptionType(autoDeliverInput, firstTimeInput, hiddenBlocks, shownBlocks, firstTimeBlocks) {
  if (autoDeliverInput.checked) {
    hiddenBlocks.forEach((block) => { hideBlock(block) });
    firstTimeBlocks.forEach((block) => { hideBlock(block) });
    shownBlocks.forEach((block) => { showBlock(block) });
  } else if (firstTimeInput && firstTimeInput.checked) {
    hiddenBlocks.forEach((block) => { hideBlock(block) });
    shownBlocks.forEach((block) => { hideBlock(block) });
    firstTimeBlocks.forEach((block) => { showBlock(block) });
  } else {
    shownBlocks.forEach((block) => { hideBlock(block) });
    firstTimeBlocks.forEach((block) => { hideBlock(block) });
    hiddenBlocks.forEach((block) => { showBlock(block) });
  }
}

function hideBlock(block) {
  block.style.display = "none";
}

function showBlock(block) {
  block.style.display = "";
}
